import { styled } from '@mui/material/styles';
import { MOBILE_BREAKPOINT } from '@src/constants';
import { BREAKPOINTS, FLASH_SALE_BANNER_HEIGHT } from '@src/styles/config';

export const StyledReferredOrders = styled('div')`
  .transaction-history-card {
    margin: 16px 4px;
    min-height: ${(props) =>
      props.isShowHeaderBanner
        ? `calc(100vh - 48px - ${FLASH_SALE_BANNER_HEIGHT}px)`
        : 'calc(100vh - 48px)'};
    display: flex;

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      padding: 20px;
      margin: 8px 0;
      display: flex;
      gap: 24px;
    }

    @media only screen and (max-width: ${BREAKPOINTS.MXS}px) {
      padding: 0;
    }
    .vnd {
      text-decoration: underline;
    }
  }

  .transaction-history-loading {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .transaction-history-wrapper {
    display: flex;
    flex-direction: column;
    max-width: 1135px;
    width: 100%;
    margin: 0 auto;
    flex: 1;
  }

  .transaction-history-table {
    padding: 0 24px 24px 24px;
    gap: 24px;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
`;

export const StyledReferredOrdersHeader = styled('div')`
  display: flex;
  align-items: center;
  padding: 24px 24px 0 24px;
  gap: 16px;
`;
